"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { create } from "zustand";
import { getActions } from "./actions.js";
const DEFAULT_EX_WALLET_PROVIDER_STATE = {
  EvmProvider: void 0,
  evmContext: void 0,
  SolanaProvider: void 0,
  solanaContext: void 0,
  CosmosProvider: void 0,
  cosmosContext: void 0,
  connectParaEvmWallet: void 0,
  connectParaCosmosWallet: void 0,
  fullAuthWallets: []
};
const useExternalWalletProviderStore = create((set) => __spreadValues(__spreadValues({}, DEFAULT_EX_WALLET_PROVIDER_STATE), getActions(set)));
export {
  useExternalWalletProviderStore
};
